import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { UPPERCASE_INPUT } from "../../../Forms/formStyles";
import { MdmFormProps } from "../../../Forms/MdmFormProps";
import { Edc } from "../../Edc";
import { TextFieldInput } from "../../../Forms/TextFieldInput";

export const EdcGsdbForm = ({ disabledFields }: MdmFormProps) => {
  const { control } = useFormContext<Edc>();

  return (
    <BorderedFormGrid>
      <Grid item xs={3}>
        <TextFieldInput
          name="Gsdb"
          control={control}
          label="GSDB"
          required
          disabledFields={disabledFields}
          inputProps={UPPERCASE_INPUT}
        />
      </Grid>
      {/* PLACEHOLDER PARENT GSDB */}
      <Grid item xs={3} />
      <Grid item xs={3} />
    </BorderedFormGrid>
  );
};
